import BulkAction from '../components/BulkAction'

export default class AdDesignJobsCombines {
  constructor(params) {
    this.params = params;
  }

  show() {
    let ba = new BulkAction({
      target: "#combine-bulk-store",
      action: "#combine-bulk-action",
      secondary_nav: "#combine-action-bar",
      checked_scope: "td.checkable",
    })

    this.bindCombineModal();
  }

  bindCombineModal() {
    N2.handle('click', '#combine-modal', (evt) => {
      $('#js-combine-modal').modal('show');
      $('.modal-backdrop').addClass('in');
    });

    N2.handle("click", ".js-combine-confirm", (evt) => {
      evt.preventDefault()
      $("#combine-form").submit();
    })
  }
}
